// In-memory print dedup guard.
// Print history does not need to survive app restarts — a Map is sufficient.

const MAX_ENTRIES = 20000;
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

// Map<orderId, timestamp>
const printedOrders = new Map();

/**
 * Checks if the order has already been printed in this session.
 * @param {string} orderId
 * @returns {Promise<boolean>}
 */
export const hasPrintedLocal = async (orderId) => {
  if (!orderId) return false;
  return printedOrders.has(orderId);
};

/**
 * Marks an order as printed.
 * @param {string} orderId
 */
export const markPrintedLocal = async (orderId) => {
  if (!orderId) return;
  printedOrders.set(orderId, Date.now());

  // Optional: Auto-cleanup (1% chance to run)
  if (Math.random() < 0.01) {
    cleanOldRecords();
  }
};

const cleanOldRecords = () => {
  if (printedOrders.size > MAX_ENTRIES) {
    const cutoff = Date.now() - THIRTY_DAYS_MS;
    for (const [id, ts] of printedOrders) {
      if (ts < cutoff) {
        printedOrders.delete(id);
      }
    }
  }
};
